module.exports = __webpack_public_path__ + "img/hot_content_bg.f625e162.png";